import { Box } from '@/ui';

export const PrintBackground = () => {
  return (
    <Box bg="gray.700" inset="0" pointerEvents="none" pos="fixed" zIndex={-1} />
  );
};
